module.exports = __webpack_public_path__ + "static/img/cop_sch_logo4.61bd4c8f.png";